import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

class ConfirmationModal extends Component {
    render() {
        let modalHeader = null;

        if (this.props.title) {
            modalHeader = (
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
            );
        }

        return (
            <Modal show={this.props.show} onHide={this.props.noClicked} backdrop="static">
                {modalHeader}
                {this.props.children &&
                    <Modal.Body>
                        {this.props.children}
                    </Modal.Body>
                }
                <Modal.Footer>
                    <Button bsStyle="default" onClick={this.props.noClicked}>{this.props.noText}</Button>
                    <Button bsStyle="danger" onClick={this.props.yesClicked}>{this.props.yesText}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
};

ConfirmationModal.defaultProps = {
    show: false,
    title: 'Are you sure?',
    yesText: 'Yes! Get rid of it!',
    noText: 'No! Take me back!'
};

ConfirmationModal.propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string,
    yesText: PropTypes.string,
    noText: PropTypes.string,
    noClicked: PropTypes.func.isRequired,
    yesClicked: PropTypes.func.isRequired
};

export default ConfirmationModal;